import { get } from 'lodash';
export const getCustomerID = () => {
  const store = 'store' in window ? window.store.getState() : {};
  const customerId = get(store, 'common.profiles.0.customer_id', null);
  return customerId;
};